// Vendor imports
const React = require('react')
const ReactRedux = require('react-redux')
// Client V2 common imports
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const toastActions = require('client-v2/common/containers/toasts/actions')

const errorMessage = 'Sorry, we could not send the SMS. Please contact support@mix.com.'
const successMessage = 'SMS sent. Go check your phone!'

/**
 * @see https://help.branch.io/using-branch/docs/text-me-the-app
 */
function useTextMeTheAppCallback() {
  const branch = typeof window === 'object' ? window.branch : null
  const dispatch = ReactRedux.useDispatch()
  return React.useCallback(
    (phoneNumber, onError, onSuccess) => {
      // Branch may not initialize if the browser has tracking prevention enabled
      if (!branch || branch._q) {
        dispatch(confirmModalActions.alert(errorMessage))
        return
      }
      const linkData = {
        tags: [ 'sms-app', 'mix-web' ],
        channel: 'Website',
        feature: 'TextMeTheApp'
      }
      branch.sendSMS(phoneNumber, linkData, {}, error => {
        if (error) {
          if (onError) {
            onError()
          } else {
            // Fallback: show ConfirmModal
            dispatch(confirmModalActions.alert(errorMessage))
          }
        } else {
          if (onSuccess) {
            onSuccess()
          } else {
            // Fallback: show Toast
            dispatch(toastActions.showNotice({
              message: successMessage
            }))
          }
        }
      })
    },
    [ branch, dispatch ]
  )
}

module.exports = {
  useTextMeTheAppCallback
}
